import { render, staticRenderFns } from "./form1.1.vue?vue&type=template&id=60c43bd2&scoped=true&"
import script from "./form1.1.vue?vue&type=script&lang=js&"
export * from "./form1.1.vue?vue&type=script&lang=js&"
import style0 from "./form1.1.vue?vue&type=style&index=0&id=60c43bd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c43bd2",
  null
  
)

export default component.exports